import type { TFunction } from 'i18next';
import type { Order, TimedStatus } from '../../types/Order';
import { BOARD_STATUSES } from './config';

/** "just now", "4 min", "1 h", "1 h 12 min" */
export const formatElapsed = (minutes: number, t: TFunction): string => {
    if (minutes < 1) return t('time.now');
    if (minutes < 60) return t('time.min', { n: minutes });
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m === 0 ? t('time.hour', { h }) : t('time.hourMin', { h, m });
};

/** Time spent in a state: "0 min", "under 1 min", then as formatElapsed. */
export const formatDuration = (minutes: number, t: TFunction): string =>
    minutes <= 0 ? t('time.min', { n: 0 }) : minutes < 1 ? t('time.lessThanMin') : formatElapsed(Math.floor(minutes), t);

export const minutesSince = (iso: string, now: number): number => Math.max(0, Math.floor((now - Date.parse(iso)) / 60_000));

/** Seconds spent in each board state: the API's totals, with the current state running on to `now`. */
export const liveSeconds = (order: Order, now: number): Record<TimedStatus, number> => {
    const run = Math.max(0, (now - Date.parse(order.timing.asOf)) / 1000);
    const out = { ...order.timing.seconds };
    for (const s of BOARD_STATUSES) if (s === order.status) out[s] += run;
    return out;
};
